import React from "react";

const EditDealers = () => {
  return <h1>Αντιπρόσωποι</h1>;
};

export default EditDealers;
